import Splide from "@splidejs/splide";

export default class Offer {

	static getHolderSelectors = () => ['.offer-element'];

	/** @type {HTMLElement} */
	#holderElement;

	/** @param {HTMLElement} holderElement */
	constructor(holderElement) {
		this.#holderElement = holderElement;

		const relatedOptions = holderElement.querySelector('.related-options');
		if (!relatedOptions) {
			return;
		}

		const slider = new Splide(relatedOptions.querySelector('.splide'), {
			type: 'loop',
			perPage: 3,
			perMove: 1,
			pagination: false,
			arrows: false,
			gap: '2rem',
			breakpoints: {
					768: {
						perPage: 1,
					},
					960: {
						perPage: 2,
					}
				}
		});
		slider.mount();

		const arrowsElement = relatedOptions.querySelector('.slider-arrows');
		if (!arrowsElement) {
			return;
		}
		const sliderControls = arrowsElement.querySelectorAll('[data-slider-control]');
		sliderControls.forEach(sliderControl => {
			sliderControl.addEventListener('click', () => {
				slider.go(sliderControl.dataset.sliderControl);
			});
		});

	}

}
